import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../configs/translations'

import styles from './ManagerCockpitNoFilteredData.module.scss'

export const ManagerCockpitNoFilteredData = () => (
  <section className={styles.root} role="status" aria-live="polite">
    <div className={styles.icon} aria-hidden="true">
      <i className="kbase kbase-filter" />
    </div>
    <div className={styles.accent} aria-hidden="true" />
    <h2 className={styles.title}>
      <Translation span text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.managerCockpit.noFilteredData} />
    </h2>
  </section>
)

ManagerCockpitNoFilteredData.displayName = 'ManagerCockpitNoFilteredData'
